import { render } from "./ProjectProvinceSummary.vue?vue&type=template&id=a5ad454c&scoped=true&ts=true"
import script from "./ProjectProvinceSummary.ts?vue&type=script&lang=ts"
export * from "./ProjectProvinceSummary.ts?vue&type=script&lang=ts"

import "./ProjectProvinceSummary.scss?vue&type=style&index=0&id=a5ad454c&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a5ad454c"]])

export default __exports__